/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e=["begin","end","begin-end"],n=["arrow","circle","square","diamond","cross","x"];export{e as lineMarkerPlacements,n as lineMarkerStyles};
